import router from '@/router';

/**
 * @deprecated This is just a placeholder until the switch to Vue3. Please use the composable provided by vue-router instead.
 */
export function useRouter () {
    return router;
}
